<app-page-content>
<app-doenkids-menu-bar menuBar>
  <div left>
    <mat-checkbox [formControl]="viewSharedFoldersControl">
      {{ 'pinboard.view-shared-pinboard-folders' | translate }}
    </mat-checkbox>
  </div>
</app-doenkids-menu-bar>
<div content class="page-container" #pageContainer *ngVar="(currentFolders$ | async) as folder">
  <h2>{{ 'pinboard.title' | translate: {organization: currentOuName$ | async} }}</h2>
  <p>{{ 'pinboard.description' | translate }}</p>
  @if (folder?.folders.length === 0) {
    <p>{{ 'pinboard.no_folders' | translate }}</p>
  }
  <div class="folders">
    @if (!(isReader$ | async)) {
    <div>
      <div
        id="new-pinbord-button"
        role="button"
        class="image-panel flex-row items-center justify-center"
        (click)="addNewFolder()"
        [matTooltip]="'pinboard.folder.add.tooltip' | translate"
        >
        <mat-icon>create_new_folder</mat-icon>
      </div>
      <div class="title-panel">
        <h3 class="mat-title">{{ 'pinboard.folder.add.tooltip' | translate }}</h3>
      </div>
    </div>
    }
    @if (folder?.folders?.length > 0) {
      @for (fav of (folder?.folders ?? []) | paginate
        : {
        id: 'pinbord-pagination-controls',
        itemsPerPage: itemsPerPage,
        currentPage: currentPage,
        totalItems: folder?.folders?.length ?? 0
        }; track fav) {
        <app-pinbord-folder
          (click)="goToFolder(fav)"
          [folder]="fav"
        ></app-pinbord-folder>
      }
    }
  </div>
  @if (folder?.totalNoOfFolders > itemsPerPage) {
    <pagination-controls
      id="pinbord-pagination-controls"
      [nextLabel]="'generic.pagination.next' | translate"
      [previousLabel]="'generic.pagination.previous' | translate"
      (pageChange)="paginate($event)"
    ></pagination-controls>
  }
</div>
</app-page-content>
